import './../sass/main.scss';
// import $ from 'jquery';
import LocomotiveScroll from 'locomotive-scroll';
import {tns} from 'tiny-slider/src/tiny-slider';
import { MarkerClusterer, GridAlgorithm } from "@googlemaps/markerclusterer";


require('select2/dist/js/select2.js');

var $ = require('jquery');
var imagesLoaded = require('imagesloaded');
var scroll;

imagesLoaded.makeJQueryPlugin( $ );

$(function() {

    if(!$('.js-noscroll').length) {
        scroll = new LocomotiveScroll({
            el:     $('#staalmeester')[0],
            smooth: false
        });
    }

    $('.js-expandmore').click(function(ev) {
        ev.preventDefault();
        if($(this).attr('data-direction') == 'out') {
            $('.e-article__collapsed').addClass('e-article__collapsed--expanded');
            $(this).attr('data-direction', 'in').text(wp_object.collapse_text);
        } else {
            $('.e-article__collapsed').removeClass('e-article__collapsed--expanded');
            $(this).attr('data-direction', 'out').text(wp_object.read_more);
        }
    });

    $('.js-expandsearch').click(function(ev) {
        if($('.e-search__input').hasClass('e-search__input--open')) {
            $(this).closest('form').submit();
        }

        else {
            ev.preventDefault();
            $('.e-search__input').addClass('e-search__input--open').focus();
            $(this).removeClass('js-expandsearch');
        }
    });

    $('.js-expandfaq').click(function(ev) {
        ev.preventDefault();
        let isOpen = $(this).parent().hasClass('e-faq__qa--open');
        $('.e-faq__qa').removeClass('e-faq__qa--open');
        if(!isOpen) {
            $(this).parent().addClass('e-faq__qa--open');
            setTimeout(function() {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".e-faq__qa--open").offset().top - 112
                }, 500);
            }, 300);
        }
    });

    $('.js-faqanchor').click(function(ev) {
        ev.preventDefault();
        let faqCategory = $(this).attr('href');
        $('.e-faq__button').removeClass('e-faq__button--active');
        $(this).addClass('e-faq__button--active');
        $('.e-faq__category').removeClass('e-faq__category--active');
        $(faqCategory).addClass('e-faq__category--active');
    });

    $('.js-formstep').click(function(ev) {
        ev.preventDefault();
        $('.e-form__fieldset').removeClass('e-form__fieldset--active');
        $('.e-form__step').removeClass('e-form__step--active');
        let dataStep = $(this).attr('data-step');
        $('.e-form__step[data-step="' + dataStep + '"]').addClass('e-form__step--active');
        $('.e-form__fieldset[data-step="' + dataStep + '"]').addClass('e-form__fieldset--active');
        scroll.scrollTo( $('.e-form__progress')[0], {duration:300} );
    });

    $('.js-megamenu').hover(function(ev) {
        ev.stopPropagation();
        $('.l-megamenu').addClass('l-megamenu--shown');
        let currentMenu = $(this).attr('class').split('js-megamenu--')[1];
        $('.e-megamenu').removeClass('e-megamenu--shown');
        $('.e-megamenu--' + currentMenu).addClass('e-megamenu--shown');
    });

    $('.l-megamenu').mouseleave(function(ev) {
        $('.l-megamenu').removeClass('l-megamenu--shown');
        setTimeout(function() {
            $('.e-megamenu').removeClass('e-megamenu--shown');
        },500);
    });

    var previousHistoryId = -1;
    $(document).on('scroll', function() {
        if($(window).scrollTop() > 0) {
            $('.l-megamenu').addClass('l-megamenu--scrolled');
        } else {
            $('.l-megamenu').removeClass('l-megamenu--scrolled');
        }

        if($('.js-timeline').length) {
            let historyId = 0;
            $('[data-historyitem]').each(function() {
                let historyTop = $(this).position().top;
                let windowTop = $(window).scrollTop() + ($(window).height() / 1.5);

                if(historyTop < windowTop) {
                    historyId = $(this).attr('data-historyitem');
                }

            });

            if(historyId != previousHistoryId) {
                previousHistoryId = historyId;
                $('.e-background').removeClass('e-background--active');
                $('[data-historyid="' + historyId + '"]').addClass('e-background--active');
                $('.e-timeline__year').removeClass('e-timeline__year--active');
                $('[data-historyitem="' + historyId + '"] .e-timeline__year').addClass('e-timeline__year--active');
            }
        }
    }).trigger('scroll');

    var sliders = [];
    if($('.e-carousel').length) {
        let sliderCounter = 0;
        $('.e-carousel').each(function() {
            sliderCounter++;
            $(this).attr('id', 'carousel' + sliderCounter);
            sliders.push(tns({
                autoplay:     false,
                center:       false,
                container:    '#' + $(this).attr('id'),
                controls:     true,
                controlsText: ["", ""],
                items:        1.4,
                mouseDrag:    true,
                nav:          false,
                responsive: {
                    768: {
                        items: 2.4,
                    }
                },
            }));
        });
    }

    // Styled select boxes
    $('.js-select').select2({
        minimumResultsForSearch: Infinity,
        width: 'resolve'
    });

    $('.js-select--dealers').on('change', function(ev){
        $('.e-member--store').hide();
        $('.e-member' + $(this).val()).show();
    });

    // Full screen zoom
    $(window).resize(function() {
        let scaleFactor = Math.max( $('html').innerWidth() / 1440, 1 );

        if(scaleFactor > 1) {
            $('#staalmeester').css('transform', 'scale(' + scaleFactor + ')');
            $('#staalmeester').css('-ms-transform', 'scale(' + scaleFactor + ')');

            /*
            console.log([
                0.98 * $(window).height() / scaleFactor,
                $('.e-leader').outerHeight()
            ]);
            */

            $('.l-hero').not('.l-hero--series')
                .css('padding-left', (5.5 / scaleFactor) + 'rem')
                .css('min-height', (Math.max(0.98 * $(window).height() / scaleFactor, $('.e-leader').outerHeight()) / 16) + 'rem')
                .css('height', 'auto');
            //  .css('max-height', Math.round(0.98 * $(window).height() / scaleFactor) + 'px');
        }
        else {
            $('#staalmeester').css('transform', 'none').css('-ms-transform', 'none');
        }

        $('#staalmeester').css('opacity', '1');
    }).trigger('resize');

    // Mobile menu
    $('.js-togglemenu').click(function(ev) {
        ev.preventDefault();
        $(this).toggleClass('e-menu__hamburger--toggled');
        $('.l-offcanvas').toggleClass('l-offcanvas--toggled');
    });

    // Re-pad images
    if($('.l-featured').length) {
        let maxPadding = 0;
        $('.l-featured').imagesLoaded(function(){
            $('.js-repad').each(function(ev) {
                let imageHeight = $('img', $(this)).height();
                maxPadding = Math.max(maxPadding, imageHeight);
            });
            $('.js-repad').css('padding-top', 'calc(' + maxPadding + 'px - 4.5rem');
        });
    }

    // Expand/collapse mobile submenu
    $('.js-mobexpand').click(function(ev) {
        ev.preventDefault();
        $(this).closest('.e-menu__item').find('.sub-menu').toggleClass('sub-menu--expanded');
    });


    // Expand/collapse filters
    $('.js-expandfilter').click(function(ev) {
        ev.preventDefault();
        let $filterList = $(this).closest('.e-filter__item').find('.e-filter__list--sub');
        let isExpanded = $filterList.hasClass('e-filter__list--expanded');
        $('.e-filter__list--sub').removeClass('e-filter__list--expanded');
        if(!isExpanded) {
            $(this).closest('.e-filter__item').find('.e-filter__list--sub').addClass('e-filter__list--expanded');
        }
    });

    // Hide headings if no series selected
    if( $('.js-hidefiltertitle').length ) {
        $('[data-seriesvalue]').hide();
    }

    // XHR filter
    var doXhr = true;
    $('.js-addfilter').change(function(ev) {

        // Reset results page
        $('[name="paged"]').val('1');

        // Reset selected label
        let dataLabel = $(this).attr('name') + ':' + $(this).attr('value');
        $('[data-value="' + dataLabel + '"]').remove();

        // Update filter button badge
        let $filterList = $(this).closest('.js-badgefilter');
        $filterList.removeClass('e-filter__item--selected');

        let selectedLength = $('.js-addfilter:checked', $filterList).length;
        if(selectedLength) {
            $('.e-filter__badge', $filterList).text(selectedLength);
            $filterList.addClass('e-filter__item--selected');
        }

        if(doXhr) {
            // Add selected filter to active list
            if($(this).is(':checked')) {
                let $liLabel = $('<li>').addClass('e-filter__item js-removefilter')
                    .attr('data-value', dataLabel)
                    .appendTo('[data-activefilters]');
                $('<a>').addClass('e-filter__link')
                    .text( $(this).closest('label').text() )
                    .appendTo($liLabel);
            }

            // Post data, get results
            xhrFilter();
        }
    });

    $('body').on('click', '.js-removefilter', function(ev) {
        ev.preventDefault();
        $('[name="paged"]').val('1');
        let dataLabel = $(this).attr('data-value').split(':');
        let inputTag = 'input[name="' + dataLabel[0] + '"][value="' + dataLabel[1] + '"]';
        $(inputTag).prop('checked', false);

        $('.js-badgefilter').each(function(){
            $('.js-addfilter', $(this)).first().trigger('change');
        });
        
        $(this).remove();
        xhrFilter();
    });

    $('body').on('click', '.js-pagefilter', function(ev) {
        ev.preventDefault();
        $('[name="paged"]').val($(this).attr('data-page'));
        xhrFilter();
    });

    $(document).click(function(ev) {
        if(!$(ev.target).closest('.js-badgefilter').length) {
            $('.e-filter__list--sub').removeClass('e-filter__list--expanded');
        }
    });

    // Pre-select filters
    $('.js-badgefilter').each(function(){
        doXhr = false;
        $('.js-addfilter', $(this)).first().trigger('change');
        doXhr = true;
    });

    // Pre-fill labels
    $('.js-addfilter').each(function() {
        if($(this).is(':checked')) {
            let dataLabel = $(this).attr('name') + ':' + $(this).attr('value');
            let $liLabel = $('<li>').addClass('e-filter__item js-removefilter')
                .attr('data-value', dataLabel)
                .appendTo('[data-activefilters]');
            $('<a>').addClass('e-filter__link')
                .text( $(this).closest('label').text() )
                .appendTo($liLabel);
        }
    });

    // Equalize height of content sliders
    if($('.js-equalizeheight').length) {
        var equalHeights = {};
        $('.js-equalizeheight').each(function() {
            let key = $(this).attr('data-compare');
            if(typeof equalHeights[key] == 'undefined') {
                equalHeights[key] = 0;
            }
            equalHeights[key] = Math.max(equalHeights[key], $(this).height());
        });

        for(let element in equalHeights) {
            $('[data-compare="' + element + '"]').height(equalHeights[element]);
        }
    }



    if($('#locationsMap').length) {

        const StaalmeesterRenderer = {
            render({count, position}, stats) {
                const color = count > Math.max(10, stats.clusters.markers.mean) ? "#5b1c2f" : "#5b1c2f";
                const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
            <circle cx="120" cy="120" opacity=".6" r="70" />
            <circle cx="120" cy="120" opacity=".3" r="90" />
            <circle cx="120" cy="120" opacity=".2" r="110" />
            <text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
            </svg>`;
                return new google.maps.Marker({
                    position,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                    title: `<?php _e('Found ${count} dealers here', 'staalmeester'); ?>`,
                    icon: {
                        url: `data:image/svg+xml;base64,${btoa(svg)}`,
                        anchor: new google.maps.Point(25, 25)
                    }
                });
            }
        };

        // Define custom cluster algorithm
        const StaalmeesterAlgorithm = new GridAlgorithm({gridSize: 50});

        // Initialize Google Maps
        async function initLocations() {

            const { Map, InfoWindow, Geocoder } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

            const locationsMap = new Map(document.getElementById('locationsMap'), {
                center: {lat: 52.132633, lng: 5.291266},
                zoom: 7,
                mapId: 'c03b13bfa5c4fb35',
                disableDefaultUI: true,
                zoomControl: true,
                clickableIcons: false,
            });

            locationsMap.addListener('zoom_changed', () => {
                infoWindow.close();
            })

            locationsMap.addListener('recenter', (address) => {

                if(!address.length) {
                    this.setZoom(7);
                    this.setCenter({lat: 52.132633, lng: 5.291266});
                    return;
                }

                const geocoder = new google.maps.Geocoder();

                geocoder.geocode(
                    { 'address': address },
                    function(results,status) {
                        if (status === google.maps.GeocoderStatus.OK) {
                            locationsMap.setCenter(results[0].geometry.location);
                            locationsMap.setZoom(11);
                        } else {
                            console.log('Google Geocode error: ' + status);
                        }
                    }
                );
            });

            $('.js-dealerinput button').click(function() {
                google.maps.event.trigger(locationsMap, 'recenter', $('.js-dealerinput input').val().trim());
            });

            const infoWindow = new google.maps.InfoWindow({
                maxWidth: 750,
                autopanMargin: 10,
                content: ""
            });

            const staalMarkers = staalMarkerDealers.map((dealer, i) => {

                const marker = new google.maps.marker.AdvancedMarkerElement({
                    // map: locationsMap,
                    position: { lat: dealer.lat, lng: dealer.lng },
                    content: $('<img>').css({'height':'1.25rem', 'width':'auto'}).attr('src', wp_object.theme_url + '/assets/map-marker.png')[0],
                    title: dealer.name,
                });

                marker.addListener('click', () => {
                    infoWindow.setContent('<p class="e-map__infowindow"><strong>'
                        + dealer.name
                        + '</strong><br>'
                        + dealer.address
                        + '</p>'
                    );
                    // infoWindow.setPosition(ev.latLng);
                    infoWindow.open(locationsMap, marker);
                });

                return marker;
            });

            const markerCluster = new MarkerClusterer({
                markers:     staalMarkers,
                renderer:    StaalmeesterRenderer,
                algorithm:   StaalmeesterAlgorithm,
                map:         locationsMap
            });
        }

        initLocations();

        // Async call for dealers
        $('.js-dealerinput input').keyup(function(ev) {
            if(ev.which == 13) {
                $('.js-dealerinput button').trigger('click');
            }
        });
    }


    // iOS low power play button fix
    if($('.js-autoplay').length) {
        $('.js-autoplay').each(function() {
            let heroVideo = $('video', $(this))[0];
            if(heroVideo.paused) {
                try { heroVideo.play(); }
                catch(err) { $(this).hide(); }
            }
        });
    }

    // Timeline background flash prevention
    if($('.l-timeline-background').length) {
        setTimeout(function() {
            $('.l-timeline-background').show();
        }, 1000);
    }

});



// Helper function for asynchronous filtering and searching
function xhrFilter() {
    $('.xhr-products').addClass('xhr-products--loading');

    $.ajax({
        type: "GET",
        url: wp_object.theme_url + '/xhr/filter.php',
        data: $('.js-xhrfilter').serialize(),

        success: function(msg) {
            // Filter groups if any
            if(msg.reset_tag) {
                // May have to become more dynamic in the future
                $('[name="product_tag[]"]').closest('.e-filter__item').show();
            }
            if(msg.groups.length) {
                $('[name="product_tag[]"]').closest('.e-filter__item').hide();
                for(let key in msg.groups) {
                    $('[name="product_tag[]"][value="' + msg.groups[key] + '"]').closest('.e-filter__item').show();
                }
            }

            // Filter attributes if any
            if(msg.reset_attr) {
                // May have to become more dynamic in the future
                $('[name="diameter-kwast[]"]').closest('.e-filter__item').show();
            }
            if(typeof msg.pa == 'object') {
                for(let current_pa in msg.pa) {
                    if(msg.pa[current_pa].length) {
                        $('[name="' + current_pa + '[]"]').closest('.e-filter__item').hide();
                        for(let skey in msg.pa[current_pa]) {
                            // console.log([current_pa, msg.pa[current_pa][skey]]);
                            $('[name="' + current_pa + '[]"][value="' + msg.pa[current_pa][skey] + '"]').closest('.e-filter__item').show();
                        }
                    }
                }
            }

            // Show results
            $('.xhr-products').html(msg.html);
            $('.xhr-products').removeClass('xhr-products--loading');
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.js-xhrfilter').offset().top - 112
            }, 500);
        },

        error: function(staal,mees,ter) {
            $('.xhr-products').removeClass('xhr-products--loading');
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.js-xhrfilter').offset().top - 112
            }, 500);
        }
    });
}
